import type { RouteRecordRaw } from 'vue-router';

export const tradeSurveyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/survey',
    name: 'tradeSurvey',
    redirect: '/trade/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Surveys Service - for private & public surveys',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/trade/survey/project',
    name: 'tradeSurveyProject',
    redirect: '/trade/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Survey Projects - for private & public surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyProjectList',
        component: () => import('pages/micros/survey/project/SurveyList.vue'),
        meta: {
          title: 'Survey Projects List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyProjectDetail',
        component: () => import('pages/micros/survey/project/SurveyDetail.vue'),
        meta: {
          title: 'Support Project Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyProjectNew',
        component: () => import('pages/micros/survey/project/SurveyNew.vue'),
        meta: {
          title: 'New Survey Project',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/access',
    name: 'tradeSurveyAccess',
    redirect: '/trade/survey/access/list',
    component: () => import('pages/micros/survey/access/SurveyAccess.vue'),
    meta: {
      title: 'Survey access assignment for private surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyAccessList',
        component: () => import('pages/micros/survey/access/SurveyAccessList.vue'),
        meta: {
          title: 'Survey Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyAccessDetail',
        component: () => import('pages/micros/survey/access/SurveyAccessDetail.vue'),
        meta: {
          title: 'Survey Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyAccessNew',
        component: () => import('pages/micros/survey/access/SurveyAccessNew.vue'),
        meta: {
          title: 'New Survey Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/category',
    name: 'tradeSurveyCategory',
    redirect: '/trade/survey/category/list',
    component: () => import('pages/micros/survey/category/SurveyCategory.vue'),
    meta: {
      title: 'Survey Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyCategoryList',
        component: () => import('pages/micros/survey/category/SurveyCategoryList.vue'),
        meta: {
          title: 'Survey Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyCategoryDetail',
        component: () => import('pages/micros/survey/category/SurveyCategoryDetail.vue'),
        meta: {
          title: 'Survey Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyCategoryNew',
        component: () => import('pages/micros/survey/category/SurveyCategoryNew.vue'),
        meta: {
          title: 'New Survey Category',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/question',
    name: 'tradeSurveyQuestion',
    redirect: '/trade/survey/question/list',
    component: () => import('pages/micros/survey/question/SurveyQuestion.vue'),
    meta: {
      title: 'Survey Questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyQuestionList',
        component: () => import('pages/micros/survey/question/SurveyQuestionList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyQuestionDetail',
        component: () => import('pages/micros/survey/question/SurveyQuestionDetail.vue'),
        meta: {
          title: 'Survey Question Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyQuestionNew',
        component: () => import('pages/micros/survey/question/SurveyQuestionNew.vue'),
        meta: {
          title: 'New Survey Question',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/answer',
    name: 'tradeSurveyAnswer',
    redirect: '/trade/survey/answer/list',
    component: () => import('pages/micros/survey/answer/SurveyAnswer.vue'),
    meta: {
      title: 'Survey Answers / Expectations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyAnswerList',
        component: () => import('pages/micros/survey/answer/SurveyAnswerList.vue'),
        meta: {
          title: 'Survey Answers / Expectations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyAnswerDetail',
        component: () => import('pages/micros/survey/answer/SurveyAnswerDetail.vue'),
        meta: {
          title: 'Survey Answer / Expectation Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyAnswerNew',
        component: () => import('pages/micros/survey/answer/SurveyAnswerNew.vue'),
        meta: {
          title: 'New Survey Answer / Expectation',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/responder',
    name: 'tradeSurveyResponder',
    redirect: '/trade/survey/responder/list',
    component: () => import('pages/micros/survey/responder/SurveyResponder.vue'),
    meta: {
      title: 'Survey Responders to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyResponderList',
        component: () => import('pages/micros/survey/responder/SurveyResponderList.vue'),
        meta: {
          title: 'Survey Responders List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyResponderDetail',
        component: () => import('pages/micros/survey/responder/SurveyResponderDetail.vue'),
        meta: {
          title: 'Survey Responder Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyResponderNew',
        component: () => import('pages/micros/survey/responder/SurveyResponderNew.vue'),
        meta: {
          title: 'New Survey Responder',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/response',
    name: 'tradeSurveyResponse',
    redirect: '/trade/survey/response/list',
    component: () => import('pages/micros/survey/response/SurveyResponse.vue'),
    meta: {
      title: 'Survey Responses to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyResponseList',
        component: () => import('pages/micros/survey/response/SurveyResponseList.vue'),
        meta: {
          title: 'Survey Responses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyResponseDetail',
        component: () => import('pages/micros/survey/response/SurveyResponseDetail.vue'),
        meta: {
          title: 'Survey Response Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyResponseNew',
        component: () => import('pages/micros/survey/response/SurveyResponseNew.vue'),
        meta: {
          title: 'New Survey Response',
          requiresAuth: true,
        },
      },
      {
        path: 'wizard/:itemId?',
        name: 'tradeSurveyResponseExplorer',
        component: () => import('pages/micros/survey/response/SurveyResponseExplorer.vue'),
        meta: {
          title: 'Survey Vote Response Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'result/:itemId?',
        name: 'tradeSurveyResponseResult',
        component: () => import('pages/micros/survey/response/SurveyResponseResult.vue'),
        meta: {
          title: 'Survey Vote Response Result',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/trade/survey/vote',
    name: 'tradeSurveyVote',
    redirect: '/trade/survey/vote/list',
    component: () => import('pages/micros/survey/vote/SurveyVote.vue'),
    meta: {
      title: 'Survey voting',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyVoteList',
        component: () => import('pages/micros/survey/vote/VoteList.vue'),
        meta: {
          title: 'Survey Votes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyVoteDetail',
        component: () => import('pages/micros/survey/vote/VoteDetail.vue'),
        meta: {
          title: 'Survey Vote Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyVoteNew',
        component: () => import('pages/micros/survey/vote/VoteNew.vue'),
        meta: {
          title: 'New Survey Vote',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'tradeSurveyVoteExplorer',
        component: () => import('pages/micros/survey/vote/VoteExplorer.vue'),
        meta: {
          title: 'Survey Votes Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'view/:itemId?',
        name: 'tradeSurveyVoteView',
        component: () => import('pages/micros/survey/vote/VoteView.vue'),
        meta: {
          title: 'Survey Vote View',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/stat',
    name: 'tradeSurveyStat',
    redirect: '/trade/survey/stat/list',
    component: () => import('pages/micros/survey/stat/VoteStat.vue'),
    meta: {
      title: 'Survey voting stats',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyStatList',
        component: () => import('pages/micros/survey/stat/StatList.vue'),
        meta: {
          title: 'Survey Voting Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyStatDetail',
        component: () => import('pages/micros/survey/stat/StatDetail.vue'),
        meta: {
          title: 'Survey Voting Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyStatNew',
        component: () => import('pages/micros/survey/stat/StatNew.vue'),
        meta: {
          title: 'New Survey Stat',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/trade/survey/comment',
    name: 'tradeSurveyComment',
    redirect: '/trade/survey/comment/list',
    component: () => import('pages/micros/survey/comment/SurveyComment.vue'),
    meta: {
      title: 'Information Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyCommentList',
        component: () => import('pages/micros/survey/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyCommentDetail',
        component: () => import('pages/micros/survey/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyCommentNew',
        component: () => import('pages/micros/survey/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'tradeSurveyCommentStatList',
        component: () => import('pages/micros/survey/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'tradeSurveyCommentStatDetail',
        component: () => import('pages/micros/survey/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'tradeSurveyCommentStatNew',
        component: () => import('pages/micros/survey/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/rate',
    name: 'tradeSurveyRate',
    redirect: '/trade/survey/rate/list',
    component: () => import('pages/micros/survey/rate/SurveyRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyRateList',
        component: () => import('pages/micros/survey/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyRateDetail',
        component: () => import('pages/micros/survey/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyRateNew',
        component: () => import('pages/micros/survey/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/rating',
    name: 'tradeSurveyRating',
    redirect: '/trade/survey/rating/list',
    component: () => import('pages/micros/survey/rating/SurveyRating.vue'),
    meta: {
      title: 'Ratings by Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyRatingList',
        component: () => import('pages/micros/survey/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'tradeSurveyRatingDetail',
        component: () => import('pages/micros/survey/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeSurveyRatingNew',
        component: () => import('pages/micros/survey/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/view',
    name: 'tradeSurveyView',
    redirect: '/trade/survey/view/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Views - page views',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyViewList',
        component: () => import('pages/micros/survey/view/ViewList.vue'),
        meta: {
          title: 'Views List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/share',
    name: 'tradeSurveyShare',
    redirect: '/trade/survey/share/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Shares - page shared with others',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeSurveyShareList',
        component: () => import('pages/micros/survey/view/ShareList.vue'),
        meta: {
          title: 'Shares List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/survey/bookmark',
    name: 'tradeSurveyBookmark',
    redirect: '/trade/survey/bookmark/list',
    component: () => import('pages/micros/survey/bookmark/SurveyBookmark.vue'),
    meta: {
      title: 'Information Bookmarks - for information products...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'tradeSurveyBookmarkList',
        component: () => import('pages/micros/survey/bookmark/BookmarkList.vue'),
        meta: {
          title: 'Bookmarks List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'tradeSurveyBookmarkDetail',
        component: () => import('pages/micros/survey/bookmark/BookmarkDetail.vue'),
        meta: {
          title: 'Bookmark Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'tradeSurveyBookmarkNew',
        component: () => import('pages/micros/survey/bookmark/BookmarkNew.vue'),
        meta: {
          title: 'New Bookmark',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'tradeSurveyBookmarkExplorer',
        component: () => import('pages/micros/survey/bookmark/BookmarkExplorer.vue'),
        meta: {
          title: 'Bookmarks Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
